module.exports = __webpack_public_path__ + "static/slider-1-1f584323c43fda0a9aa4098c1c59b0d7.png";